export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType(window.PMW.emails.styles.ID_STYLE_HEADER, {
        /**
         *
         * @param {object} props
         * @param {string} props.classes
         * @param {string} props.text
         * @param change
         * @return {HTMLSpanElement}
         */
        create({props, change}) {
            // default, list,
            const el = document.createElement('span');
            el.className = window.PMW.emails.styles.ID_STYLE_HEADER;

            if (typeof props.classes === 'string') {
                el.className += ` ${props.classes}`;
            }

            if (typeof props.text === 'string') {
                el.innerHTML += props.text;
            }

            return el;
        },
        emit({props}, {el, event, complete}) {
        },
        update({value, el}) {
        }
    })
}